// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var section = "WeContactYou-module--section--xxDrQ";
export var isLandingPage = "WeContactYou-module--isLandingPage--2FP-X";
export var noPaddingTop = "WeContactYou-module--noPaddingTop--1tSZk";
export var container = "WeContactYou-module--container--1YjKV";
export var title = "WeContactYou-module--title--2jvUM";
export var topInfo = "WeContactYou-module--topInfo--1aJ0A";
export var infoIcon = "WeContactYou-module--infoIcon--15Wi9";
export var content = "WeContactYou-module--content--3t1qR";
export var blockContainer = "WeContactYou-module--blockContainer--2ui4F";
export var blueBordersLabel = "WeContactYou-module--blueBordersLabel--10iWq";
export var block = "WeContactYou-module--block--Wqe53";
export var infoBlock = "WeContactYou-module--infoBlock--vNH3G";
export var stepTwoBlock = "WeContactYou-module--stepTwoBlock--3vutA";
export var textArea = "WeContactYou-module--textArea--2iNKb";
export var maxCharactersNotice = "WeContactYou-module--maxCharactersNotice--3BiTE";
export var stepOneBlock = "WeContactYou-module--stepOneBlock--Hu3ov";
export var stepThreeBlock = "WeContactYou-module--stepThreeBlock--1PkfZ";